// Keep in sync with the API
export const AUDIT_TYPE = {
  CREATE_TENANT: "CREATE_TENANT",
  UPDATE_TENANT: "UPDATE_TENANT",
  CREATE_CATEGORY: "CREATE_CATEGORY",
  UPDATE_CATEGORY: "UPDATE_CATEGORY",
  DELETE_CATEGORY: "DELETE_CATEGORY",
  CREATE_MACHINE: "CREATE_MACHINE",
  UPDATE_MACHINE: "UPDATE_MACHINE",
  DELETE_MACHINE: "DELETE_MACHINE",
  CREATE_MATERIAL: "CREATE_MATERIAL",
  UPDATE_MATERIAL: "UPDATE_MATERIAL",
  DELETE_MATERIAL: "DELETE_MATERIAL",
  CREATE_ADDITIONAL_EFFORT: "CREATE_ADDITIONAL_EFFORT",
  UPDATE_ADDITIONAL_EFFORT: "UPDATE_ADDITIONAL_EFFORT",
  DELETE_ADDITIONAL_EFFORT: "DELETE_ADDITIONAL_EFFORT",
  CREATE_CONSTRUCTION_REPORT: "CREATE_CONSTRUCTION_REPORT",
  UPDATE_CONSTRUCTION_REPORT: "UPDATE_CONSTRUCTION_REPORT",
  PRINT_CONSTRUCTION_REPORT: "PRINT_CONSTRUCTION_REPORT",
  DELETE_CONSTRUCTION_REPORT: "DELETE_CONSTRUCTION_REPORT",
  CREATE_CONTACT_POSITION: "CREATE_CONTACT_POSITION",
  UPDATE_CONTACT_POSITION: "UPDATE_CONTACT_POSITION",
  DELETE_CONTACT_POSITION: "DELETE_CONTACT_POSITION",
  CREATE_CUSTOMER: "CREATE_CUSTOMER",
  UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
  DELETE_CUSTOMER: "DELETE_CUSTOMER",
  CREATE_FILE_TAG: "CREATE_FILE_TAG",
  CREATE_HOURLY_WAGE_INVOICE: "CREATE_HOURLY_WAGE_INVOICE",
  UPDATE_HOURLY_WAGE_INVOICE: "UPDATE_HOURLY_WAGE_INVOICE",
  CREATE_HOURLY_WAGE_REPORT: "CREATE_HOURLY_WAGE_REPORT",
  BILL_HOURLY_WAGE_REPORT: "BILL_HOURLY_WAGE_REPORT",
  PRINT_HOURLY_WAGE_REPORT: "PRINT_HOURLY_WAGE_REPORT",
  UPDATE_HOURLY_WAGE_REPORT: "UPDATE_HOURLY_WAGE_REPORT",
  DELETE_HOURLY_WAGE_REPORT: "DELETE_HOURLY_WAGE_REPORT",
  CREATE_HOURLY_WAGE_REPORT_TAG: "CREATE_HOURLY_WAGE_REPORT_TAG",
  DELETE_HOURLY_WAGE_REPORT_TAG: "DELETE_HOURLY_WAGE_REPORT_TAG",
  CREATE_PACKET: "CREATE_PACKET",
  UPDATE_PACKET: "UPDATE_PACKET",
  DELETE_PACKET: "DELETE_PACKET",
  CREATE_USER_CUSTOM_FIELD: "CREATE_USER_CUSTOM_FIELD",
  CREATE_USER_POSITION: "CREATE_USER_POSITION",
  UPDATE_USER_POSITION: "UPDATE_USER_POSITION",
  DELETE_USER_POSITION: "DELETE_USER_POSITION",
  CREATE_USER: "CREATE_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",
  UPDATE_USER_PASSWORD: "UPDATE_USER_PASSWORD",
  CREATE_PROJECT: "CREATE_PROJECT",
  UPDATE_PROJECT: "UPDATE_PROJECT",
  DELETE_PROJECT: "DELETE_PROJECT",
  DUPLICATE_PROJECT: "DUPLICATE_PROJECT",
  CREATE_MONTAGE_ELEMENT: "CREATE_MONTAGE_ELEMENT",
  UPDATE_MONTAGE_ELEMENT: "UPDATE_MONTAGE_ELEMENT",
  DELETE_MONTAGE_ELEMENT: "DELETE_MONTAGE_ELEMENT",
  CREATE_SERVICE_CATALOG_ITEM: "CREATE_SERVICE_CATALOG_ITEM",
  UPDATE_SERVICE_CATALOG_ITEM: "UPDATE_SERVICE_CATALOG_ITEM",
  DELETE_SERVICE_CATALOG_ITEM: "DELETE_SERVICE_CATALOG_ITEM",
  CREATE_CHANGE_ORDER: "CREATE_CHANGE_ORDER",
  UPDATE_CHANGE_ORDER: "UPDATE_CHANGE_ORDER",
  DELETE_CHANGE_ORDER: "DELETE_CHANGE_ORDER",
  CREATE_SERVICE_PROGRESS: "CREATE_SERVICE_PROGRESS",
  UPDATE_SERVICE_PROGRESS: "UPDATE_SERVICE_PROGRESS",
  DELETE_SERVICE_PROGRESS: "DELETE_SERVICE_PROGRESS",
  CREATE_ROLE: "CREATE_ROLE",
  UPDATE_ROLE: "UPDATE_ROLE",
  DELETE_ROLE: "DELETE_ROLE",
  CREATE_TEAM: "CREATE_TEAM",
  UPDATE_TEAM: "UPDATE_TEAM",
  CREATE_CALENDAR: "CREATE_CALENDAR",
  UPDATE_CALENDAR: "UPDATE_CALENDAR",
  DELETE_CALENDAR: "DELETE_CALENDAR",
  CREATE_ABSENCE: "CREATE_ABSENCE",
  UPDATE_ABSENCE: "UPDATE_ABSENCE",
  CREATE_ASSIGNMENT: "CREATE_ASSIGNMENT",
  UPDATE_ASSIGNMENT: "UPDATE_ASSIGNMENT",
  DELETE_ASSIGNMENT: "DELETE_ASSIGNMENT",
  CREATE_DATA_EXPORT: "CREATE_DATA_EXPORT",
  CREATE_WORK_TIME_MODEL: "CREATE_WORK_TIME_MODEL",
  UPDATE_WORK_TIME_MODEL: "UPDATE_WORK_TIME_MODEL",
  DELETE_WORK_TIME_MODEL: "DELETE_WORK_TIME_MODEL",
  CREATE_PDF_LETTERHEAD: "CREATE_PDF_LETTERHEAD",
  UPDATE_PDF_LETTERHEAD: "UPDATE_PDF_LETTERHEAD",
  DELETE_PDF_LETTERHEAD: "DELETE_PDF_LETTERHEAD",
  CREATE_PDF_TEMPLATE: "CREATE_PDF_TEMPLATE",
  UPDATE_PDF_TEMPLATE: "UPDATE_PDF_TEMPLATE",
  DELETE_PDF_TEMPLATE: "DELETE_PDF_TEMPLATE",
  CREATE_TIME_ENTRY: "CREATE_TIME_ENTRY",
  UPDATE_TIME_ENTRY: "UPDATE_TIME_ENTRY",
  DELETE_TIME_ENTRY: "DELETE_TIME_ENTRY",
  CREATE_VOICE_VOCABULARY: "CREATE_VOICE_VOCABULARY",
  UPDATE_VOICE_VOCABULARY: "UPDATE_VOICE_VOCABULARY",
  DELETE_VOICE_VOCABULARY: "DELETE_VOICE_VOCABULARY",
  CREATE_DAY_SUBMISSION: "CREATE_DAY_SUBMISSION",
  UPDATE_DAY_SUBMISSION: "UPDATE_DAY_SUBMISSION",
  DISMISS_DAY_SUBMISSION: "DISMISS_DAY_SUBMISSION",
  REOPEN_DAY_SUBMISSION: "REOPEN_DAY_SUBMISSION",
  CONVERT_DAY_SUBMISSION: "CONVERT_DAY_SUBMISSION",
  // Archived / restored (docs/archiving.md); an employee archived has left the company.
  ARCHIVE_PROJECT: "ARCHIVE_PROJECT",
  RESTORE_PROJECT: "RESTORE_PROJECT",
  ARCHIVE_CUSTOMER: "ARCHIVE_CUSTOMER",
  RESTORE_CUSTOMER: "RESTORE_CUSTOMER",
  ARCHIVE_USER: "ARCHIVE_USER",
  RESTORE_USER: "RESTORE_USER",
  ARCHIVE_MACHINE: "ARCHIVE_MACHINE",
  RESTORE_MACHINE: "RESTORE_MACHINE",
  ARCHIVE_MATERIAL: "ARCHIVE_MATERIAL",
  RESTORE_MATERIAL: "RESTORE_MATERIAL",
  ARCHIVE_ADDITIONAL_EFFORT: "ARCHIVE_ADDITIONAL_EFFORT",
  RESTORE_ADDITIONAL_EFFORT: "RESTORE_ADDITIONAL_EFFORT",
  ARCHIVE_CATEGORY: "ARCHIVE_CATEGORY",
  RESTORE_CATEGORY: "RESTORE_CATEGORY",
  ARCHIVE_USER_POSITION: "ARCHIVE_USER_POSITION",
  RESTORE_USER_POSITION: "RESTORE_USER_POSITION",
  ARCHIVE_WORK_TIME_MODEL: "ARCHIVE_WORK_TIME_MODEL",
  RESTORE_WORK_TIME_MODEL: "RESTORE_WORK_TIME_MODEL",
}
